import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  Signal,
  viewChild,
} from '@angular/core';
import { ModalComponent } from '@appkit4/angular-components/modal';
import { TaxNewsPanel } from '../../models/tax-news-panel';

@Component({
  standalone: false,
  selector: 'gstar-tax-news-detail-modal',
  templateUrl: './tax-news-detail-modal.component.html',
  styleUrls: ['./tax-news-detail-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaxNewsDetailModalComponent {
  readonly taxNews: InputSignal<TaxNewsPanel | undefined> = input<
    TaxNewsPanel | undefined
  >(undefined);

  modal: Signal<ModalComponent | undefined> = viewChild(ModalComponent);

  openTaxNewsModal(): void {
    this.modal()?.showModal('tax-news-detail-modal');
  }
}
